import rgbaToCss from '@mixins/rgba-to-css'

export default {

    methods: {
        buttonStyle(style) {
            if (!style ||
                !style.color ||
                !style.color ||
                !style.backgroundColor ||
                !style.borderColor)
                return {}

            return {
                'color': style.color.active ?
                    this.rgbaToCss(style.color.color) : null,
                'background-color': style.backgroundColor.active ?
                    this.rgbaToCss(style.backgroundColor.color) : null,
                'border-color': style.borderColor.active ?
                    this.rgbaToCss(style.borderColor.color) : null,
            }
        },
    },

    mixins: [rgbaToCss]

}
